var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"fsc-btn fsc-btn-border",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.label)?_c('span',{staticClass:"font-weight-bold text-tuatara-500"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }